var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgZenGuy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 222.888,
    height: 300,
    viewBox: "0 0 222.888 300",
    className: "img",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.aa,.ab,.ac,.ad,.aj,.ak,.bj,.w,.x,.y,.z{fill:none;}.b{fill:#efefef;}.c{clip-path:url(#c);}.d{clip-path:url(#d);}.e{clip-path:url(#e);}.f{fill:url(#f);}.g{clip-path:url(#g);}.h{fill:url(#h);}.i{clip-path:url(#i);}.j{fill:url(#j);}.k{clip-path:url(#k);}.l{fill:url(#l);}.m{clip-path:url(#m);}.n{fill:url(#n);}.o{clip-path:url(#o);}.p{fill:url(#p);}.q{clip-path:url(#q);}.r{fill:url(#r);}.s{clip-path:url(#s);}.t{fill:url(#t);}.u{clip-path:url(#u);}.v{fill:url(#v);}.aa,.aj,.w,.x,.y,.z{stroke:#c8c8c8;stroke-dasharray:3.32 3.32;}.aa,.ab,.ac,.ad,.aj,.ak,.w,.x,.y,.z{stroke-linecap:round;}.ac,.ad,.aj,.bj,.w,.x,.y,.z{stroke-miterlimit:10;}.w{stroke-width:0.448px;}.x{stroke-width:0.448px;}.aa,.ab,.y{stroke-width:0.448px;}.z{stroke-width:0.448px;}.ab,.ac,.ad,.ak{stroke:#b9b9b9;}.ac{stroke-width:0.896px;}.ad,.ak{stroke-width:0.896px;}.ae{clip-path:url(#w);}.af{fill:#f0f0f0;}.ag{clip-path:url(#x);}.ah{fill:url(#y);}.ai{clip-path:url(#z);}.aj{stroke-width:0.448px;}.al{clip-path:url(#aa);}.am{clip-path:url(#ad);}.an{fill:url(#ae);}.ao{clip-path:url(#af);}.ap{fill:url(#ag);}.aq{clip-path:url(#ah);}.ar,.ay,.az{isolation:isolate;}.as{clip-path:url(#ai);}.at{fill:url(#aj);}.au{fill:#f4d9c3;}.av,.bb{fill:#fff;}.av{opacity:0.18;}.aw{clip-path:url(#ak);}.ax{fill:#f1f1f1;}.ay{fill:#e3e3e3;}.ay,.az{mix-blend-mode:multiply;}.az{fill:url(#al);}.ba{fill:#33c999;}.bc{fill:#282829;}.bd{fill:#47484a;}.be{clip-path:url(#am);}.bf{fill:#281100;}.bg{clip-path:url(#ao);}.bh{fill:#eac5b5;}.bi{fill:#cea293;}.bj{stroke:#4b4b4d;stroke-width:0.892px;}.bk{fill:#4b4b4d;}.bl{fill:#542700;}.bm{fill:#925f2d;}.bn{filter:url(#ab);}.bo{filter:url(#a);}"), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 91.401,
    y: 71.798,
    width: 61.675,
    height: 82.521,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M69.3,312.572s15.584,23.072,23.477,49.261l23.477-6.679L103.827,299.7Z",
    transform: "translate(-69.3 -299.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 172.151,
    height: 193.965
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M279.7,18.581a4.169,4.169,0,0,0,3.319,4.857h.81a4.169,4.169,0,0,0,.769-8.257l-.769-.081a4.169,4.169,0,0,0-4.088,3.4",
    transform: "translate(-279.625 -15.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: -11.004,
    y1: 18.5,
    x2: -10.964,
    y2: 18.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffff96"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#22b896"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "g"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M279.6,23.417a4.169,4.169,0,1,0,8.257-.891l-2.874,1.9L283.122,22Z",
    transform: "translate(-279.6 -22)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: -12.273,
    y1: 25.841,
    x2: -12.229,
    y2: 25.841,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "i"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M92.455,337.262a3.441,3.441,0,0,0-2.631,5.141h.081a3.441,3.441,0,0,0,2.914,1.579h0a3.441,3.441,0,0,0,0-6.881h-.364",
    transform: "translate(-89.365 -337.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    x1: -3.633,
    y1: 6.122,
    x2: -3.591,
    y2: 6.122,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "k"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M95.386,341.852l-2.469-.526L91.5,344.119a3.441,3.441,0,1,0,4.655-5.019Z",
    transform: "translate(-91.5 -339.1)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "l",
    x1: -3.847,
    y1: 6.256,
    x2: -3.803,
    y2: 6.256,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "m"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.648,185.962h-.121a2.024,2.024,0,0,0-.931,1.822,3.279,3.279,0,0,0,.445,1.619v.081a2.874,2.874,0,0,0,2.267,1.457h.04a1.74,1.74,0,0,0,.85-.243,2.024,2.024,0,0,0,.931-1.821,3.279,3.279,0,0,0-.445-1.619h-.04a2.834,2.834,0,0,0-2.307-1.457,1.741,1.741,0,0,0-.729.162",
    transform: "translate(-15.592 -185.8)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "n",
    x1: -0.514,
    y1: 11.624,
    x2: -0.467,
    y2: 11.624,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "o"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M19.788,189.483l-1.66-.567L17.4,190.9a2.378,2.378,0,0,0,2.955.891c.931-.526,1.214-2.145.445-3.441a3.4,3.4,0,0,0-.688-.85Z",
    transform: "translate(-17.4 -187.5)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "p",
    x1: -0.611,
    y1: 12.508,
    x2: -0.562,
    y2: 12.508,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "q"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M249.375,423.3a2.186,2.186,0,0,0-1.336,1.214,2.428,2.428,0,0,0-.243,1.012,1.5,1.5,0,0,0,.81,1.417,1.256,1.256,0,0,0,.526.121h0a1.983,1.983,0,0,0,1.619-1.093h.081a2.428,2.428,0,0,0,.243-1.012,1.5,1.5,0,0,0-.81-1.417,1.255,1.255,0,0,0-.526-.121h-.364",
    transform: "translate(-247.794 -423.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "r",
    x1: -24.939,
    y1: 4.964,
    x2: -24.838,
    y2: 4.964,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "s"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M364.083,210.109a2.307,2.307,0,0,0-.486,1.376,1.417,1.417,0,0,0,.526,1.174,1.3,1.3,0,0,0,.769.243h0a2.1,2.1,0,0,0,1.538-.81h.081a2.307,2.307,0,0,0,.486-1.376,1.417,1.417,0,0,0-.526-1.174,1.3,1.3,0,0,0-.769-.243,2.145,2.145,0,0,0-1.66.931",
    transform: "translate(-363.596 -209.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "t",
    x1: -26.159,
    y1: 25.317,
    x2: -26.087,
    y2: 25.317,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "u"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M363.984,211.981a1.735,1.735,0,0,0,.243,2.226,1.888,1.888,0,0,0,2.429-.688,2.508,2.508,0,0,0,.364-.688l-1.417.364-.081-1.3Z",
    transform: "translate(-363.702 -211.9)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "v",
    x1: -26.329,
    y1: 25.63,
    x2: -26.256,
    y2: 25.63,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "w"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.2,110.593s17.405,38.292,22.708,61.243l33.313-5.667S132.79,120.591,135.5,99.3Z",
    transform: "translate(-86.2 -99.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "x"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M107.39,136.3h-.243a3.314,3.314,0,0,0-2.348,3.481,5.06,5.06,0,0,0,.081.971v.081c.4,1.9,1.781,3.238,3.279,3.238h.486a3.314,3.314,0,0,0,2.348-3.481,5.06,5.06,0,0,0-.081-.971,3.726,3.726,0,0,0-3.319-3.319h-.2",
    transform: "translate(-104.799 -136.3)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "y",
    x1: -3.201,
    y1: 9.386,
    x2: -3.168,
    y2: 9.386,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "z"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M86.2,110.593s17.405,38.292,22.708,61.243l33.313-5.667S132.79,120.591,135.5,99.3Z",
    transform: "translate(-86.2 -99.3)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aa"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bo",
    transform: "matrix(1, 0, 0, 1, 0, 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M241.694,192.2a110.1,110.1,0,0,1-17.851,1.174h-.04c-12.71,0-24.975-1.174-24.975-1.174a47.606,47.606,0,0,0-.729,9.715c0,19.51,4.938,54.2,4.938,54.2,5.5.445,10.605.607,14.977.607h.04c8.7,0,14.41-.607,14.41-.607,6.315-16.636,9.31-63.914,9.31-63.914h-.081",
    transform: "translate(-198.1 -192.2)"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "ab",
    x: 91.401,
    y: 68.798,
    width: 61.675,
    height: 82.517,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "ac"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "ac"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M208,215.769a4.169,4.169,0,1,0,4.169-4.169A4.169,4.169,0,0,0,208,215.769",
    transform: "translate(-208 -211.6)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ae",
    x1: -7.44,
    y1: 9.869,
    x2: -7.404,
    y2: 9.869,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "af"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M213.564,220.188l-2.267-2.064-3.2,2.064a4.169,4.169,0,1,0,7.934-2.388Z",
    transform: "translate(-208.1 -217.8)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ag",
    x1: -8.596,
    y1: 13.018,
    x2: -8.554,
    y2: 13.018,
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "ah"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M198.828,192.2c-3,13.317,4.21,63.914,4.21,63.914a178.137,178.137,0,0,0,29.387,0c6.314-16.636,9.31-63.914,9.31-63.914-15.3,2.672-42.947,0-42.947,0",
    transform: "translate(-198.099 -192.2)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ai"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M219.008,88.483c-9.8,5.338-26.837,0-26.837,0-43.218-19.452-64.351-64.936-70.933-81.975A10.238,10.238,0,0,0,111.731,0h0a10.238,10.238,0,0,0-9.507,6.436C95.5,23.4,73.925,69.031,30.707,88.483c0,0-16.965,5.338-26.837,0s0,8.921,18.793,8.044a63.324,63.324,0,0,0,10.75-1.243l2.633,6.655s41.682-23.181,64.132-73.273C95.059,60.987,84.09,110.64,64.638,122.487h93.529c-19.525-11.846-30.421-61.5-35.539-93.821,22.523,50.092,64.132,73.273,64.132,73.273l2.633-6.655a63.325,63.325,0,0,0,10.75,1.243C219.008,97.4,228.807,83.145,219.008,88.483Z",
    transform: "translate(0.021 0)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "aj",
    y1: 0.5,
    x2: 1,
    y2: 0.5,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#174e64"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#182440"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ak"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M212.9,174.91H128.582s-35.686-1.024-40.8-6.143c-3.071-3.071,112.176-22.45,132.578-14.991S229.277,174.91,212.9,174.91Z",
    transform: "translate(-87.718 -152.081)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "al",
    x1: 0.53,
    y1: 0.278,
    x2: 0.418,
    y2: 1.694,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "am"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M38.25,174.933h92.359s-.292-3.144-.292-6.728c0-.219-.219-.731,0-.878s1.1-.292,0-1.755-.146-1.463-.878-2.706,1.9-1.463,0-1.755c-34.881-5.923-85.558-11.993-98.648-7.24C10.389,161.332,21.943,174.933,38.25,174.933Z",
    transform: "translate(-19.884 -152.166)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ao"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32.348,51.86a.658.658,0,0,0-.951.658c.585,4.241,1.389,13.967-3.218,13.455-5.85-.731-4.388-19.013-4.388-19.013a125.923,125.923,0,0,1-6.581-11.7c-.366-.8-2.34-.731-2.925-1.463-2.413-3.144-.219-5.411-.731-6.581A23.546,23.546,0,0,1,12.092,22.1C9.167,8.935,28.911-.133,35.493,8.789s3.656,16.234,7.313,19.89,4.241,3.8,1.974,5.192-3.437.658-3.437.658S40.1,51.714,36,52.3a6.143,6.143,0,0,1-3.656-.439Z",
    transform: "translate(-11.799 -5.221)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-468 -273.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(493.215 273.999)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(28.051 121.312)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H46.954V62.149H0Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "d"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M323.3,240.3s1.457-31.734,18.741-40.4c0,0,14.855,5.869,22.546,9.877,0,0-21.979,15.867-24.287,30.52Z",
    transform: "translate(-192.436 -118.985)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.644,202.366S5.667,176.7,0,171.076c0,0,22.465-10,28.051-7.974,0,0,9.229,20.32,14.248,34.973Z",
    transform: "translate(0 -96.921)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M266.093.265s-10.969,26.31-4.331,61.243c0,0,25.622.81,35.3,4.412,0,0,8.338-45.011,21.979-62.012,0,0-38.292-4.979-52.945-3.643",
    transform: "translate(-154.537 -0.022)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M233.91,416.648s-7.974,11.415-9.31,23.841l14.167,1.093s6.8-18.62,15.139-25.582Z",
    transform: "translate(-116.687 -263.613)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "e",
    transform: "translate(113.186 6.112)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "f",
    width: 10.2,
    height: 10.2,
    transform: "translate(-2.066 0.539) rotate(-14.8)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "g",
    transform: "translate(113.176 8.905)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "h",
    width: 9.188,
    height: 7.185,
    transform: "translate(-0.893 0.05) rotate(-8.7)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "i",
    transform: "translate(36.173 136.45)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "j",
    width: 9.593,
    height: 9.593,
    transform: "matrix(0.568, -0.823, 0.823, 0.568, -3.223, 4.834)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "k",
    transform: "translate(37.037 137.26)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "l",
    width: 9.269,
    height: 9.277,
    transform: "matrix(0.652, -0.758, 0.758, 0.652, -3.307, 3.839)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "m",
    transform: "translate(6.311 75.207)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "n",
    d: "M14.16,179.3l5.141,4.25-3.4,6.193-5.1-4.25Z",
    transform: "translate(-12.74 -181.931)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "o",
    transform: "translate(7.043 75.896)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "p",
    d: "M16.164,181.5l4.453,4.412-3.764,5.222L12.4,186.722Z",
    transform: "translate(-14.424 -183.929)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "q",
    transform: "translate(117.301 155.342)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "r",
    d: "M250.907,422.1l-.364,4.25-3.643.4.364-4.25Z",
    transform: "translate(-247.262 -422.586)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "s",
    transform: "translate(147.175 84.72)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "t",
    d: "M366.586,208.7l-1.174,3.926L361,212.186l1.174-3.886Z",
    transform: "translate(-362.051 -208.705)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "u",
    transform: "translate(147.218 85.772)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "v",
    d: "M366.245,211.031l-1.3,3.319-4.25-.931L362,210.1Z",
    transform: "translate(-361.915 -210.829)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "w",
    d: "M358.9,221.9s10,2.388,15.746,5.95",
    transform: "translate(-213.626 -132.08)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "x",
    d: "M354.8,229.3s10,2.388,15.746,5.95",
    transform: "translate(-211.185 -136.485)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    x2: 35.742,
    y2: 4.453,
    transform: "translate(113.176 17.648)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    x2: 35.701,
    y2: 4.453,
    transform: "translate(112.123 23.153)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    y1: 8.338,
    x2: 23.275,
    transform: "translate(39.628 140.053)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    y1: 8.176,
    x2: 22.587,
    transform: "translate(41.409 144.222)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    y1: 5.991,
    x2: 19.065,
    transform: "translate(10.565 77.798)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    y1: 4.21,
    x2: 19.308,
    transform: "translate(11.9 82.251)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "z",
    x2: 11.091,
    transform: "translate(116.575 160.806)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aa",
    d: "M0,0,2.019.22l8.748.954",
    transform: "translate(114.956 162.587)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ab",
    d: "M0,0,2.019.22l8.748.954",
    transform: "translate(111.956 170.587)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    x2: 28.172,
    y2: 4.007,
    transform: "translate(110.666 52.054)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 10.888,
    y2: 1.133,
    transform: "translate(110.666 46.711)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 10.888,
    y2: 1.133,
    transform: "translate(110.666 43.837)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 18.215,
    y2: 2.024,
    transform: "translate(128.193 29.63)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 6.193,
    x2: 12.75,
    transform: "translate(51.245 149.727)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    y1: 3.117,
    x2: 7.286,
    transform: "translate(57.64 154.139)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 4.655,
    x2: 17.122,
    transform: "translate(52.702 170.128)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    y1: 4.493,
    x2: 17.567,
    transform: "translate(52.702 173.204)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    y1: 1.821,
    x2: 17.324,
    transform: "translate(15.422 87.998)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 1.983,
    x2: 7.124,
    transform: "translate(24.084 89.82)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 4.655,
    x2: 17.001,
    transform: "translate(21.534 97.794)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 11.981,
    y2: 2.226,
    transform: "translate(133.293 116.657)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 13.317,
    y2: 5.343,
    transform: "translate(142.643 95.77)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 7.407,
    y2: 1.336,
    transform: "translate(140.417 98.766)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 5.991,
    y2: 1.781,
    transform: "translate(139.284 101.113)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    x2: 8.419,
    y2: 1.538,
    transform: "translate(93.584 189.678)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 172.151,
    height: 193.965
  }), /*#__PURE__*/React.createElement("g", {
    className: "ae",
    transform: "translate(29.892 2.194)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "af",
    d: "M86.2,110.593s17.405,38.292,22.708,61.243l33.313-5.667S132.79,120.591,135.5,99.3Z",
    transform: "translate(-86.2 -99.3)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M86.2,110.593s17.405,38.292,22.708,61.243l33.313-5.667S132.79,120.591,135.5,99.3l-37.725,8.642Z",
    transform: "translate(-86.2 -99.3)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ag",
    transform: "translate(37.42 17.171)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ah",
    d: "M104.343,127.2l5.262,8.7-7.043,6.476-5.262-8.7Z",
    transform: "translate(-100.335 -130.883)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ai",
    transform: "translate(29.892 2.194)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "z",
    y1: 6.638,
    x2: 32.625,
    transform: "translate(11.617 20.522)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "aj",
    d: "M118.2,174.067s26.472-6.234,32.342-5.545",
    transform: "translate(-105.247 -140.471)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M0,5.141,15.483,2.249,27.525,0",
    transform: "translate(14.936 33.596)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ak",
    d: "M0,5.141,15.483,2.249,27.525,0",
    transform: "translate(24.936 58.596)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    y1: 2.469,
    x2: 16.312,
    transform: "translate(16.636 39.587)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 0.81,
    x2: 12.184,
    transform: "translate(18.741 45.456)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M191.7,230.363V199.6h8.824L207,227.691Z",
    transform: "translate(-148.996 -159.001)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "al",
    transform: "translate(80.186 77.798)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bn",
    transform: "matrix(1, 0, 0, 1, -105.4, -77.8)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M0,0H43.675V64.517H0Z",
    transform: "translate(105.4 77.8)"
  }))), /*#__PURE__*/React.createElement("g", {
    className: "am",
    transform: "translate(84.194 85.651)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "an",
    width: 11.131,
    height: 11.115,
    transform: "matrix(0.904, -0.427, 0.427, 0.904, -3.258, 1.616)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "ao",
    transform: "translate(84.234 88.16)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "ap",
    width: 9.715,
    height: 8.217,
    transform: "translate(-1.862 0.77) rotate(-19.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aq",
    transform: "translate(80.186 77.798)"
  }, /*#__PURE__*/React.createElement("line", {
    className: "z",
    x2: 34.446,
    transform: "translate(4.008 20.967)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "y",
    x2: 32.908,
    transform: "translate(4.453 26.432)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    y1: 0.445,
    x2: 17.365,
    transform: "translate(4.453 30.844)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    x2: 15.948,
    transform: "translate(4.939 34.973)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ad",
    x2: 16.879,
    transform: "translate(4.939 38.859)"
  }), /*#__PURE__*/React.createElement("line", {
    className: "ac",
    x2: 24.813,
    y2: 0.688,
    transform: "translate(8.177 55.697)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(468 380.034)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(111.444 126.354)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "ar",
    transform: "translate(-111.444 -67.611)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "as"
  }, /*#__PURE__*/React.createElement("path", {
    className: "at",
    d: "M219.008,88.483c-9.8,5.338-26.837,0-26.837,0-43.218-19.452-64.351-64.936-70.933-81.975A10.238,10.238,0,0,0,111.731,0h0a10.238,10.238,0,0,0-9.507,6.436C95.5,23.4,73.925,69.031,30.707,88.483c0,0-16.965,5.338-26.837,0s0,8.921,18.793,8.044a63.324,63.324,0,0,0,10.75-1.243l2.633,6.655s41.682-23.181,64.132-73.273C95.059,60.987,84.09,110.64,64.638,122.487h93.529c-19.525-11.846-30.421-61.5-35.539-93.821,22.523,50.092,64.132,73.273,64.132,73.273l2.633-6.655a63.325,63.325,0,0,0,10.75,1.243C219.008,97.4,228.807,83.145,219.008,88.483Z",
    transform: "translate(0.021 0)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M267.821,104.5l-6.216,11.627-2.706,7.166,33.931,17.843L303.58,114.3l-8.044-9.8Z",
    transform: "translate(-69.56 -28.083)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M31.769,122.622l-3.51-7.166L18.387,102-7.5,107.411l3.583,21.426,22.3,8.044Z",
    transform: "translate(2.031 -27.411)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M-4.911,85.062c.878,0,7.093,14.187,33.931,7.093S98.709,30.509,100.537,5.5L69.824,16.688-11.2,79.65Z",
    transform: "translate(3.026 -1.478)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "av",
    d: "M235.118,90.882C208.28,83.788,165.355,29.309,163.6,4.3l30.713,11.188,81.024,63.035-6.289,5.338",
    transform: "translate(-43.95 -1.156)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "aw",
    transform: "translate(64.16 111.211)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M212.9,174.91H128.582s-35.686-1.024-40.8-6.143c-3.071-3.071,112.176-22.45,132.578-14.991S229.277,174.91,212.9,174.91Z",
    transform: "translate(-87.718 -152.081)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M229.493,204.4l-83.73-9.945s-35.32-5.192-39.781-10.9c-2.706-3.364,114.077-9.068,133.456.731S245.728,206.3,229.493,204.4Z",
    transform: "translate(-92.614 -159.268)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "az",
    d: "M192.364,179.481H96.056s-40.731-1.682-46.581-9.945c-3.51-4.973,128.117-36.49,151.372-24.351S210.938,179.481,192.364,179.481Z",
    transform: "translate(-77.422 -149.486)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M136.762,159.5c-.878,16.965,56.015.878,60.768,17.4s-1.755,12.066-1.755,12.066l-58.062-2.706L130.4,165.5Z",
    transform: "translate(-99.188 -154.075)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M128.351,167.976c.512-.512,17.258,2.121,34.881,3.583,10.165.878,23.693-.731,25.009,1.755.585,1.1-8.41,4.9-10.75,6.289-14.918,8.629,3.583,14.333,3.583,14.333l-58.062-2.706L115.7,170.462Z",
    transform: "translate(-95.237 -156.335)"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "ba",
    cx: 6.069,
    cy: 7.093,
    rx: 6.069,
    ry: 7.093,
    transform: "matrix(1, -0.005, 0.005, 1, 105.358, 21.971)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M153.223,38.829l-.439-.366.439-.366a4.1,4.1,0,0,0,.951-2.194.8.8,0,0,0-.146-.585.512.512,0,0,0-.439-.219.585.585,0,0,0-.512.512A3,3,0,0,1,152.492,37a1.463,1.463,0,0,1-2.413,0,3,3,0,0,1-.585-1.389.585.585,0,0,0-.512-.512h0a.512.512,0,0,0-.439.219.8.8,0,0,0-.146.585,4.1,4.1,0,0,0,1.024,2.194l.439.366-.439.366a4.1,4.1,0,0,0-.951,2.194.8.8,0,0,0,.146.585.512.512,0,0,0,.439.219.585.585,0,0,0,.512-.512,3,3,0,0,1,.585-1.389,1.463,1.463,0,0,1,2.413,0,3,3,0,0,1,.585,1.389.585.585,0,0,0,.512.512h0a.512.512,0,0,0,.439-.219.8.8,0,0,0,.146-.585A4.1,4.1,0,0,0,153.223,38.829Z",
    transform: "translate(-39.862 -9.433)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bc",
    d: "M168.971,164.1s-1.243,11.115.951,13.675S174.821,164.831,168.971,164.1Z",
    transform: "translate(-45.299 -44.1)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bd",
    cx: 5.85,
    cy: 17.843,
    rx: 5.85,
    ry: 17.843,
    transform: "translate(123.565 131.74) rotate(-84.4)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "bc",
    cx: 3.364,
    cy: 8.19,
    rx: 3.364,
    ry: 8.19,
    transform: "translate(122.637 129.099) rotate(-84.4)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "au",
    d: "M177.733,172.129h0a2.852,2.852,0,0,0-2.633-3.291l-6.508-.439s-.658,3.949,0,6.362l6.362-.219a2.852,2.852,0,0,0,2.779-2.413Z",
    transform: "translate(-45.213 -45.255)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "be",
    transform: "translate(14.556 111.273)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "be"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ax",
    d: "M38.25,174.933h92.359s-.292-3.144-.292-6.728c0-.219-.219-.731,0-.878s1.1-.292,0-1.755-.146-1.463-.878-2.706,1.9-1.463,0-1.755c-34.881-5.923-85.558-11.993-98.648-7.24C10.389,161.332,21.943,174.933,38.25,174.933Z",
    transform: "translate(-19.884 -152.166)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ay",
    d: "M38.25,181.5h92.359a3.8,3.8,0,0,1-.293-1.463c0-.073-.219-.146,0-.219s1.1-.073,0-.366-.146-.292-.878-.585,1.9-.292,0-.366c-34.881-1.243-85.558-2.559-98.648-1.536C10.389,178.574,21.943,181.5,38.25,181.5Z",
    transform: "translate(-19.884 -158.732)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bb",
    d: "M14.061,160.96s1.463-8.263,26.618-10.091c16.673-1.243,44.68,1.389,86,7.386C230.3,173.465,91.794,135,91.794,135l-56.307,8.995L9.6,150.21Z",
    transform: "translate(-17.12 -147.553)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(109.243 32.317)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-21.459 -32.317)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "bf",
    d: "M48.588,8.462s7.605,8.848,5.119,13.528c0,0-1.755-4.314-3.8-5.119,0,0-.366,7.751-2.559,8.19s-5.85-13.6-3.437-15.43a5.7,5.7,0,0,1,4.68-1.17Z",
    transform: "translate(-11.616 -2.202)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.598 3.862)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "bg"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "au",
    width: 51.188,
    height: 73.126,
    transform: "translate(-6.288 -9.448)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M51.394,44.494,49.2,42.3s.731,9.506,1.463,10.238S51.394,44.494,51.394,44.494Z",
    transform: "translate(-21.85 -15.185)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bh",
    d: "M36.276,48.914s-10.969-2.706-9.506-23.181S36.715,6.208,36.715,6.208,34.374-12.439,17.555-1.47,13.9,35.824,13.9,35.824l8.775,29.982,8.044.731Z",
    transform: "translate(-11.046 -2.494)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M38.05,67.641S32.931,64.863,32.2,63.4c0,0,5.119,10.238,2.194,19.744l4.388-2.194Z",
    transform: "translate(-17.281 -20.855)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bj",
    d: "M51.1,52.2s-3.656,3-7.9-.8",
    transform: "translate(-20.237 -17.631)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M41.013,30.984c-.585.146-1.024,2.413-1.243,1.17s0-2.413.658-2.559,1.316.8,1.609,2.121S41.671,30.838,41.013,30.984Z",
    transform: "translate(-19.293 -11.767)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bk",
    d: "M47.113,29.784c-.585.146-1.024,2.413-1.243,1.17s0-2.413.658-2.559,1.316.8,1.609,2.121S47.771,29.638,47.113,29.784Z",
    transform: "translate(-20.933 -11.444)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bi",
    d: "M19.79,38.941s-2.706-4.461-3.583-3.583S15.33,40.7,17.962,40.7,19.79,38.941,19.79,38.941Z",
    transform: "translate(-12.842 -13.289)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "bl",
    d: "M20.632,45.542S6.885,42.47,6.3,38.448,1.108,29.454.3,23.092-.135,2.4,11.419.715,41.693-.089,39.207,5.1s-2.413,9.726-11.993,9.141S17.561,30.039,15.587,30.7s-2.633-4.68-4.826-2.779,4.973,6.289,4.973,6.289Z",
    transform: "translate(-0.04 0.06)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "bm",
    d: "M27.648,3.555S9.147,1.215,4.979,7.943,1.1,20.959,2.932,20.521,10.683,7.5,20.19,7.8,32.329,3.848,27.648,3.555Z",
    transform: "translate(-0.475 -0.806)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZenGuy);
export default __webpack_public_path__ + "static/media/zen-guy.02fa35bfe2a6286297f03fce2f08c98f.svg";
export { ForwardRef as ReactComponent };